@if (appPhase === AppPhase.DealingCards || appPhase === AppPhase.Decision || appPhase === AppPhase.RoundEnd) {
    @if (game) {
        <app-game-switch [gameType]="gameType" [gameInstance]="game"></app-game-switch>

        <div class="count-down-container count-down-{{ gameType | lowercase }}">
            <ng-content select="[count-down]"></ng-content>
        </div>

        <ng-content select="[result-change]"></ng-content>
    } @else if (appPhase === AppPhase.RoundEnd) {
        <h2 i18n class="title-vertical-center title-white">The round has ended</h2>
    }
}
